module.exports = __webpack_public_path__ + "img/cycle.92a3103f.svg";